/** Registry key for the VhTemplateSchema entity. */
export const VH_TEMPLATE_SCHEMA = 'VhTemplateSchema';
/**
 * Standard ambient bindings available in every template (supplied via `globalData` at render time).
 * Reserved top-level keys: `org`, `now`, `user`.
 */
export const STANDARD_TEMPLATE_BINDINGS = [
    {
        path: 'org',
        label: 'Organização',
        type: 'object',
        description: 'Dados da organização (fornecidos pelo caller em globalData).',
        fields: [
            {
                path: 'name',
                label: 'Nome da organização',
                type: 'string',
                example: 'Org Exemplo',
            },
            {
                path: 'logoUrl',
                label: 'URL do logo',
                type: 'string',
                example: 'https://example.com/logo.png',
            },
        ],
    },
    {
        path: 'now',
        label: 'Data/hora atual',
        type: 'date',
        example: '2026-06-30',
        description: 'Momento da renderização; use o filtro date_br no Liquid.',
    },
    {
        path: 'user',
        label: 'Usuário',
        type: 'object',
        description: 'Usuário que originou a impressão (quando aplicável).',
        fields: [
            {
                path: 'name',
                label: 'Nome do usuário',
                type: 'string',
                example: 'Usuário Exemplo',
            },
        ],
    },
];
/** Sample `globalData` for editor preview and local smoke tests. */
export function buildStandardGlobalDataMock(now) {
    return {
        org: {
            name: 'Org Exemplo',
            logoUrl: 'https://example.com/logo.png',
        },
        now: now ?? new Date().toISOString().slice(0, 10),
        user: {
            name: 'Usuário Exemplo',
        },
    };
}
//# sourceMappingURL=templateSchema.js.map